import { render } from "./icon-windows.vue?vue&type=template&id=0f279b8c"
import script from "./icon-windows.vue?vue&type=script&lang=js"
export * from "./icon-windows.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__